import React from 'react';
import {AuthContext} from "../../authContext";

import addAttributeToEachObjectInArray from "../shared/utilities/addAttributeToEachObjectInArray";
import AddResource from "./AddResource";
import Alert from "../shared/Alert";
import Button from "../shared/Button";
import { deleteResource } from "../data/dataCIMToolkit";
import getFileSizeDescription from "../shared/utilities/getFileSizeDescription";
import { getProjectResources } from "../data/dataCIMToolkit";
import plusIcon from "../../assets/images/icons/add2.svg";
import ProjectResourcesTable from "./ProjectResourcesTable";
import Definition from "../shared/Definition";
import moment from "moment";
import Flex from "../shared/Flex";

class ProjectResources extends React.Component {
  static contextType = AuthContext;
  state = {
    isLoading: true,
    isShowForm: false,
    isCityCADUploading: false,
    isDeletingResource: false,
    deleteResource: null,
    projectResources: []
  };
  componentDidMount = async () => {
    this.loadResources();
  };
  componentDidUpdate = async () => {
    if (this.props.isNewFileSizeReady === true) {
      this.loadResources();
      this.context.cancelNewFileSizeReady();
    }
  };
  deleteResource = async () => {
    await this.setState({isDeletingResource: true});
    const deleteResourceResponse = await deleteResource(this.state.deleteResource.id, this.context.token);
    let deleteResourceName = this.state.deleteResource.name;
    await this.setState({isDeletingResource: false, deleteResource: null});
    this.props.loadProjectData();
    if (deleteResourceResponse.data === "Success") {
      this.context.addNotification({
        id: Math.random(),
        title: `Resource ${deleteResourceName} deleted.`,
        body: "",
        isAlert: true
      });
    } else {
      this.context.addNotification({
        id: Math.random(),
        title: `Sorry a problem occurred while deleting resource ${deleteResourceName}.`,
        body: "",
        isAlert: true
      });
    }
  };
  loadResources = async () => {
    if (!this.state.isLoading)
      await this.setState({isLoading: true});
    let projectResourcesResponse = await getProjectResources(this.props.projectData.ID, this.context.token);
    let projectResources = addAttributeToEachObjectInArray(projectResourcesResponse.data, 'isVisible', false);
    await this.setState({
      isLoading: false,
      projectResources: projectResources
    });
  };
  requestUploadFromCityCAD = async (resourceData, uri) => {
    document.title = "update|" + resourceData.id + "|" + resourceData.name + "|" + uri;
  };
  showDeleteResourceAlert = async resource => {
    if (resource === null)
      await this.setState({isDeletingResource: false});
    await this.setState({deleteResource: resource});
  };
  toggleAddResourceForm = () => {
    this.setState({
      isShowForm: !this.state.isShowForm
    });
  };
  toggleResourceVisibility = async id => {
    let resources = this.state.projectResources;
    let updatedResources = resources.map(resource => {
      if (resource.id === id) {
        resource.isVisible = !resource.isVisible;
      }
      return resource;
    });
    await this.setState({projectResources: updatedResources});
  };
  render() {
    if (this.state.deleteResource !== null) {
      return (
        <Alert style={{marginTop: "7px"}}>
          <h3>Delete CityCAD model?</h3>
          <p>This will permanently delete the CityCAD model.</p>
          <h4>Details</h4>
          <Definition>Name</Definition>
          {this.state.deleteResource.name}
          <Definition>Size</Definition>
          {getFileSizeDescription(this.state.deleteResource.size)}
          <Definition>Model created</Definition>
          {moment(this.state.deleteResource.createdAt).format('HH:mm D MMMM YYYY')}
          <Definition>Storage ID</Definition>
          {this.state.deleteResource.fileReference}
          <Flex style={{marginTop:"7px"}}>
            <Button onClick={() => { this.showDeleteResourceAlert(null); }}>
              Cancel
            </Button>
            <Button onClick={this.deleteResource} style={{backgroundColor:"#ff0000",border:"1px solid #aa0000",fontWeight:"bold",color:"#ffffff"}}>
              {this.state.isDeletingResource ? "Deleting" : "Delete CityCAD Model"}
            </Button>
          </Flex>
        </Alert>
      )
    }

    return (
      <div>
        {
          this.props.projectData.isCanEdit === "1"
          &&
          <Button small style={{marginTop:"10px", display:"flex", alignItems:"center"}} onClick={this.toggleAddResourceForm}>
            <img src={plusIcon} alt={`AddNewCityCADModel`} style={{width:"24px", marginRight:"10px"}} />
            <div style={{marginRight:"5px"}}>Add CityCAD model</div>
          </Button>
        }
        {
          this.state.isShowForm
          &&
          <AddResource
            projectID={this.props.projectData.ID}
            requestUploadFromCityCAD={this.requestUploadFromCityCAD}
            toggleForm={this.toggleAddResourceForm}
          />
        }
        <ProjectResourcesTable
          projectData={this.props.projectData}
          isLoading={this.state.isLoading}
          data={this.state.projectResources}
          toggleResourceVisibility={this.toggleResourceVisibility}
          showDeleteResourceAlert={this.showDeleteResourceAlert}
        />
      </div>
    )
  }
};

export default ProjectResources;
